<template>
  <div id="main" class="seatMap">
    <!-- 公司人员区域平面图 -->
    <div class="sizeBox">
      <el-slider
        vertical
        height="200px"
        v-model="value1"
        :max="30"
        :min="11"
        @change="changeDomSize2"
      ></el-slider>
      <i class="el-icon-circle-plus-outline amplification" @click="changeDomSize('add')" title="放大"></i>
      <i class="el-icon-remove-outline narrow" @click="changeDomSize('jian')" title="缩小"></i>
    </div>
    <div class="menu">
      <el-button type="text" @click="seeVisible=true" size="small">查看空置情况</el-button>A区
      <i class="tips abgc"></i>
      B区
      <i class="tips bbgc"></i>
      C区
      <i class="tips cbgc"></i>
      Z区
      <i class="tips zbgc"></i>
      <el-input
        style="width:180px;margin:5px 0 0 5px"
        size="small"
        v-model="searchName"
        @clear="clearName"
        placeholder="请输入名字"
        clearable
      >
        <el-button slot="append" icon="el-icon-search" @click="toName"></el-button>
      </el-input>
    </div>
    <div id="content2">
      <xian-A-1 :seatData="seatData" :checkList="checkList" />
      <xian-C-1 :seatData="seatData" :checkList="checkList" />
      <xian-other  />
    </div>
    <see-dialog
      :visible="seeVisible"
      :propData="seeData"
      @close="updateSeeVisible"
      @updateCheck="updateCheck"
    />
  </div>
</template>

<script>
import xianA1 from './components/xian-A-1'
import xianC1 from './components/xian-C-1'
import otherArea from './components/xian-other'

import seeDialog from './components/seeDialog'

import { companySeat } from '@/api/seat.js'

export default {
  components: {
    'xian-A-1': xianA1,
    'xian-C-1': xianC1,
    'xian-other': otherArea,
    'see-dialog': seeDialog
  },
  props: {
    activeName: {
      type: String,
      default() {
        return ''
      }
    }
  },
  watch: {
    activeName(val) {
      if (val === 'second') { // 监控 标签切换 如果是西安 就使用西安 拉取条 的 font-size 大小
        document.documentElement.style.fontSize = this.value1 + 'px'
      }
    },
    immediate: true
  },
  data() {
    return {
      value1: 11,
      seeVisible: false,
      checkList: ['A', 'B', 'C', 'Z'],
      searchName: '',
      havaClass: [],
      seeData: {
        city: 1,
        countA: 0,
        countB: 0,
        countC: 0,
        countD: 0,
        countZ: 0,
        countAall: 0,
        countBall: 0,
        countCall: 0,
        countDall: 0,
        countZall: 0,
        countAll: 0,
        all: 0,
        allKong: 0
      },
      propData: [],
      seatData: {
        // COL-A-1 开始
        A13: [
          { seat: 'A-13-08' },
          { seat: 'A-13-01' },
          { seat: 'A-13-07' },
          { seat: 'A-13-02' },
          { seat: 'A-13-06' },
          { seat: 'A-13-03' },
          { seat: 'A-13-05' },
          { seat: 'A-13-04' }
        ],
        A14: [
          { seat: 'A-14-08' },
          { seat: 'A-14-01' },
          { seat: 'A-14-07' },
          { seat: 'A-14-02' },
          { seat: 'A-14-06' },
          { seat: 'A-14-03' },
          { seat: 'A-14-05' },
          { seat: 'A-14-04' }
        ],
        A15: [
          { seat: 'A-15-08' },
          { seat: 'A-15-01' },
          { seat: 'A-15-07' },
          { seat: 'A-15-02' },
          { seat: 'A-15-06' },
          { seat: 'A-15-03' },
          { seat: 'A-15-05' },
          { seat: 'A-15-04' }
        ],
        A1: [
          { seat: 'A-01-06' },
          { seat: 'A-01-01' },
          { seat: 'A-01-05' },
          { seat: 'A-01-02' },
          { seat: 'A-01-04' },
          { seat: 'A-01-03' }
        ],
        A2: [
          { seat: 'A-02-06' },
          { seat: 'A-02-01' },
          { seat: 'A-02-05' },
          { seat: 'A-02-02' },
          { seat: 'A-02-04' },
          { seat: 'A-02-03' }
        ],
        A3: [
          { seat: 'A-03-01' },
          { seat: 'A-03-07' },
          { seat: 'A-03-02' },
          { seat: 'A-03-06' },
          { seat: 'A-03-03' },
          { seat: 'A-03-05' },
          { seat: 'A-03-04' }
        ],
        A4: [
          { seat: 'A-04-07' },
          { seat: 'A-04-01' },
          { seat: 'A-04-06' },
          { seat: 'A-04-02' },
          { seat: 'A-04-05' },
          { seat: 'A-04-03' },
          { seat: 'A-04-04' }
        ],
        A5: [
          { seat: 'A-05-08' },
          { seat: 'A-05-01' },
          { seat: 'A-05-07' },
          { seat: 'A-05-02' },
          { seat: 'A-05-06' },
          { seat: 'A-05-03' },
          { seat: 'A-05-05' },
          { seat: 'A-05-04' }
        ],
        A6: [
          { seat: 'A-06-08' },
          { seat: 'A-06-01' },
          { seat: 'A-06-07' },
          { seat: 'A-06-02' },
          { seat: 'A-06-06' },
          { seat: 'A-06-03' },
          { seat: 'A-06-05' },
          { seat: 'A-06-04' }
        ],
        A7: [
          { seat: 'A-07-07' },
          { seat: 'A-07-01' },
          { seat: 'A-07-06' },
          { seat: 'A-07-02' },
          { seat: 'A-07-05' },
          { seat: 'A-07-03' },
          { seat: 'A-07-04' }
        ],
        A8: [
          { seat: 'A-08-08' },
          { seat: 'A-08-01' },
          { seat: 'A-08-07' },
          { seat: 'A-08-02' },
          { seat: 'A-08-06' },
          { seat: 'A-08-03' },
          { seat: 'A-08-05' },
          { seat: 'A-08-04' }
        ],
        A9: [
          { seat: 'A-09-08' },
          { seat: 'A-09-01' },
          { seat: 'A-09-07' },
          { seat: 'A-09-02' },
          { seat: 'A-09-06' },
          { seat: 'A-09-03' },
          { seat: 'A-09-05' },
          { seat: 'A-09-04' }
        ],
        A10: [
          { seat: 'A-10-01' },
          { seat: 'A-10-06' },
          { seat: 'A-10-02' },
          { seat: 'A-10-05' },
          { seat: 'A-10-03' },
          { seat: 'A-10-04' }
        ],
        A11: [
          { seat: 'A-11-01' },
          { seat: 'A-11-06' },
          { seat: 'A-11-02' },
          { seat: 'A-11-05' },
          { seat: 'A-11-03' },
          { seat: 'A-11-04' }
        ],
        A12: [
          { seat: 'A-12-01' },
          { seat: 'A-12-06' },
          { seat: 'A-12-02' },
          { seat: 'A-12-05' },
          { seat: 'A-12-03' },
          { seat: 'A-12-04' }
        ],
        A16: [
          { seat: 'A-16-01' },
          { seat: 'A-16-04' },
          { seat: 'A-16-02' },
          { seat: 'A-16-03' }
        ],
        A17: [
          { seat: 'A-17-01' },
          { seat: 'A-17-04' },
          { seat: 'A-17-02' },
          { seat: 'A-17-03' }
        ],
        A18: [
          { seat: 'A-18-01' },
          { seat: 'A-18-04' },
          { seat: 'A-18-02' },
          { seat: 'A-18-03' }
        ],
        A19: [
          { seat: 'A-19-01' },
          { seat: 'A-19-04' },
          { seat: 'A-19-02' },
          { seat: 'A-19-03' }
        ],
        A20: [
          { seat: 'A-20-01' },
          { seat: 'A-20-04' },
          { seat: 'A-20-02' },
          { seat: 'A-20-03' }
        ],
        B1: [
          { seat: 'B-01-01' },
          { seat: 'B-01-04' },
          { seat: 'B-01-02' },
          { seat: 'B-01-03' }
        ],
        B2: [
          { seat: 'B-02-05' },
          { seat: 'B-02-01' },
          { seat: 'B-02-04' },
          { seat: 'B-02-02' },
          { seat: 'B-02-03' }
        ],
        B3: [
          { seat: 'B-03-06' },
          { seat: 'B-03-01' },
          { seat: 'B-03-05' },
          { seat: 'B-03-02' },
          { seat: 'B-03-04' },
          { seat: 'B-03-03' }
        ],
        B4: [
          { seat: 'B-04-01' },
          { seat: 'B-04-05' },
          { seat: 'B-04-02' },
          { seat: 'B-04-04' },
          { seat: 'B-04-03' }
        ],
        B5: [
          { seat: 'B-05-05' },
          { seat: 'B-05-01' },
          { seat: 'B-05-04' },
          { seat: 'B-05-02' },
          { seat: 'B-05-03' }
        ],
        B6: [
          { seat: 'B-06-06' },
          { seat: 'B-06-01' },
          { seat: 'B-06-05' },
          { seat: 'B-06-02' },
          { seat: 'B-06-04' },
          { seat: 'B-06-03' }
        ],
        B7: [
          { seat: 'B-07-01' },
          { seat: 'B-07-05' },
          { seat: 'B-07-02' },
          { seat: 'B-07-04' },
          { seat: 'B-07-03' }
        ],
        B8: [
          { seat: 'B-08-08' },
          { seat: 'B-08-09' },
          { seat: 'B-08-07' },
          { seat: 'B-08-10' },
          { seat: 'B-08-06' },
          { seat: 'B-08-01' },
          { seat: 'B-08-05' },
          { seat: 'B-08-02' },
          { seat: 'B-08-04' },
          { seat: 'B-08-03' }
        ],
        B9: [
          { seat: 'B-09-08' },
          { seat: 'B-09-09' },
          { seat: 'B-09-07' },
          { seat: 'B-09-10' },
          { seat: 'B-09-06' },
          { seat: 'B-09-01' },
          { seat: 'B-09-05' },
          { seat: 'B-09-02' },
          { seat: 'B-09-04' },
          { seat: 'B-09-03' }
        ],
        B10: [
          { seat: 'B-10-null1' },
          { seat: 'B-10-08' },
          { seat: 'B-10-null2' },
          { seat: 'B-10-07' },
          { seat: 'B-10-06' },
          { seat: 'B-10-01' },
          { seat: 'B-10-05' },
          { seat: 'B-10-02' },
          { seat: 'B-10-04' },
          { seat: 'B-10-03' }
        ],
        B11: [
          { seat: 'B-11-01' },
          { seat: 'B-11-02' },
          { seat: 'B-11-03' },
          { seat: 'B-11-06' },
          { seat: 'B-11-05' },
          { seat: 'B-11-04' }
        ],
        B12: [
          { seat: 'B-12-01' },
          { seat: 'B-12-02' },
          { seat: 'B-12-03' },
          { seat: 'B-12-06' },
          { seat: 'B-12-05' },
          { seat: 'B-12-04' }
        ],
        B13: [
          { seat: 'B-13-01' },
          { seat: 'B-13-02' },
          { seat: 'B-13-03' }
        ],
        B14: [
          { seat: 'B-14-06' },
          { seat: 'B-14-01' },
          { seat: 'B-14-05' },
          { seat: 'B-14-02' },
          { seat: 'B-14-04' },
          { seat: 'B-14-03' }
        ],
        B15: [
          { seat: 'B-15-01' },
          { seat: 'B-15-02' },
          { seat: 'B-15-03' },
          { seat: 'B-15-04' },
          { seat: 'B-15-05' }
        ],
        C3: [
          { seat: 'C-03-12' },
          { seat: 'C-03-11' },
          { seat: 'C-03-10' },
          { seat: 'C-03-09' },
          { seat: 'C-03-08' },
          { seat: 'C-03-07' },
          { seat: 'C-03-01' },
          { seat: 'C-03-02' },
          { seat: 'C-03-03' },
          { seat: 'C-03-04' },
          { seat: 'C-03-05' },
          { seat: 'C-03-06' }
        ],
        C2: [
          { seat: 'C-02-12' },
          { seat: 'C-02-11' },
          { seat: 'C-02-10' },
          { seat: 'C-02-09' },
          { seat: 'C-02-08' },
          { seat: 'C-02-07' },
          { seat: 'C-02-01' },
          { seat: 'C-02-02' },
          { seat: 'C-02-03' },
          { seat: 'C-02-04' },
          { seat: 'C-02-05' },
          { seat: 'C-02-06' }
        ],
        C1: [
          { seat: 'C-01-12' },
          { seat: 'C-01-11' },
          { seat: 'C-01-10' },
          { seat: 'C-01-09' },
          { seat: 'C-01-08' },
          { seat: 'C-01-07' },
          { seat: 'C-01-01' },
          { seat: 'C-01-02' },
          { seat: 'C-01-03' },
          { seat: 'C-01-04' },
          { seat: 'C-01-05' },
          { seat: 'C-01-06' }
        ],
        // COL-B-2结束
        // 前台开始
        Z1: [{ seat: 'Z-01-01' }]
        // 前台结束
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      companySeat({ city: 1 }).then(res => {
        // this.propData = res.data
        const data = [...res.data]
        const seatData = { ...this.seatData }
        // 遍历总位置数据，如果自定义数组存在就把位置数据赋值给相同位置
        this.seeData.countA = 0
        this.seeData.countB = 0
        this.seeData.countC = 0
        this.seeData.countD = 0
        this.seeData.countZ = 0

        this.seeData.countAall = 0
        this.seeData.countBall = 0
        this.seeData.countCall = 0
        this.seeData.countDall = 0
        this.seeData.countZall = 0

        this.seeData.all = 0 // 总位置数
        this.seeData.allKong = 0 // 总空置数

        Object.keys(seatData).map(key => {
          // 统计平面图实际画的总位置

          seatData[key].forEach((obj, index) => {
            this.seeData.all += 1

            if (obj.seat.indexOf('A') > -1) {
              this.seeData.countAall += 1
            } else if (obj.seat.indexOf('B') > -1) {
              this.seeData.countBall += 1
            } else if (obj.seat.indexOf('C') > -1) {
              this.seeData.countCall += 1
            } else if (obj.seat.indexOf('D') > -1) {
              this.seeData.countDall += 1
            } else if (obj.seat.indexOf('Z') > -1) {
              this.seeData.countZall += 1
            } else {
            }

            const newObj = data.find(ele => obj.seat === ele.seat)
            if (newObj) {
              seatData[key][index] = newObj
              // 统计空位置数
              if (newObj.seat.indexOf('A') > -1 && newObj.isUnused === '0') {
                this.seeData.countA += 1
              } else if (
                newObj.seat.indexOf('B') > -1 &&
                newObj.isUnused === '0'
              ) {
                this.seeData.countB += 1
              } else if (
                newObj.seat.indexOf('C') > -1 &&
                newObj.isUnused === '0'
              ) {
                this.seeData.countC += 1
              } else if (
                newObj.seat.indexOf('D') > -1 &&
                newObj.isUnused === '0'
              ) {
                this.seeData.countD += 1
              } else if (
                newObj.seat.indexOf('Z') > -1 &&
                newObj.isUnused === '0'
              ) {
                this.seeData.countZ += 1
              } else {
              }
            }
          })
        })
        this.seeData.allKong = this.seeData.countA +
        this.seeData.countB +
        this.seeData.countC +
        this.seeData.countZ
        this.seatData = seatData // 座位信息，非查看空置数据
      })
    },
    changeDomSize(type) {
      if (type === 'add' && this.value1 < 30) {
        const size = this.value1 += 1
        document.documentElement.style.fontSize = size + 'px'
      } else if (type === 'jian' && this.value1 > 11) {
        const size = this.value1 -= 1
        document.documentElement.style.fontSize = size + 'px'
      }
    },
    changeDomSize2(val) {
      this.value1 = val
      document.documentElement.style.fontSize = val + 'px'
    },
    updateSeeVisible(val) {
      this.seeVisible = val
    },
    updateCheck(val) {
      this.checkList = val
    },
    dataURLToBlob(dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    toName(val) {
      if (val) {
        const id = '#' + this.searchName
        const className = '.' + this.searchName
        const returnEle = document.querySelector(id) // productId是将要跳转区域的id,只选第一个
        if (returnEle) {
          const arr = [...this.havaClass]
          for (const i in arr) {
            if (arr[i] !== className) {
            // 移除其他 之前选中的calss
              const otherDom = document.querySelectorAll(arr[i]) // 所以和搜索名字相同的calss
              for (let t = 0; t < otherDom.length; t++) {
                const otel = otherDom[t]
                otel.classList.remove('searchClass')
              }
            }
          }
          returnEle.scrollIntoView(true)
        }
        var allClassDom = document.querySelectorAll(className) // 所以和搜索名字相同的calss
        for (let j = 0; j < allClassDom.length; j++) {
          const el = allClassDom[j]
          el.classList.add('searchClass')
        }
        this.havaClass = [className]
      }
    },
    clearName() {
      const arr = [...this.havaClass]
      for (const i in arr) {
        // 移除其他 之前选中的calss
        const otherDom = document.querySelectorAll(arr[i]) // 所以和搜索名字相同的calss
        for (let t = 0; t < otherDom.length; t++) {
          const otel = otherDom[t]
          otel.classList.remove('searchClass')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#content2 {
  // width: 210rem;
  width: 190rem;
  padding: 1rem 0 0 1rem;
  display: flex;
  /* overflow: auto; */
  height: 100%;
  margin-left: 30px;
}

.seatMap {
  overflow: auto;
  // height: 850px;
  height: calc(100vh - 180px);
}
.menu {
  padding-left: 1rem;
}
.sizeBox {
  position: fixed;
  left: 175px;
  top: 195px;
  width: 22px;
  height: 180px;
  z-index: 10;
}

.amplification {
  font-size: 20px;
  color: rgb(57, 132, 194);
  position: absolute;
  top: -28px;
  left: 9px;
  cursor: pointer;
}

.narrow {
  font-size: 20px;
  color: rgb(57, 132, 194);
  position: absolute;
  bottom: -55px;
  left: 9px;
  cursor: pointer;
}
</style>
